export const isMobile = () => {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return w <= 600;
}

export const isTablet = () => {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    return w <= 1025;
}